import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Drawer,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { t } from "i18next";

const drawerComponentStyle = {
  "& .MuiDrawer-paper": {
    width: { xs: "100%", sm: "420px" },
  },
  "& .MuiDrawer-paper .drawer-close-icon": {
    position: { xs: "absolute", sm: "fixed" },
    top: { xs: 5, sm: 16 },
    left: { xs: "auto", sm: "65%" },
    right: { xs: 5, sm: "auto" },
    zIndex: 1300,
    backgroundColor: "custom.white",
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  },
};

let paramsData = {};

const BlockTimeDrawer = forwardRef(({ selectedEvent }, ref) => {
  const { palette } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  // Use useImperativeHandle to expose open/close methods to parent components
  useImperativeHandle(ref, () => ({
    openDrawer(params) {
      paramsData = params;
      setIsOpen(true);
    },
    closeDrawer() {
      setIsOpen(false);
    },
  }));

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={() => setIsOpen(false)}
      sx={{ ...drawerComponentStyle }}
    >
      <IconButton
        className="drawer-close-icon"
        onClick={() => setIsOpen(false)}
      >
        <CloseIcon />
      </IconButton>

      <Stack height={"100vh"} justifyContent={"space-between"}>
        <Box p={2} borderBottom={`1px solid ${palette.custom.borderColor}`}>
          <Typography
            variant="h5"
            fontWeight={500}
            textTransform={"capitalize"}
          >
            {t("blockTime")}
          </Typography>
        </Box>
        <Box p={2} height={"100%"} overflow={"auto"}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Label labelText={t("type")} required />
              <CustomDropDown>
                <MenuItem>{t("lunchTime")}</MenuItem>
                <MenuItem>{t("holiday")}</MenuItem>
                <MenuItem>{t("close")}</MenuItem>
              </CustomDropDown>
            </Grid>
            <Grid item xs={12}>
              <Label labelText={t("title")} required />
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={`${t("enter")} ${t("title")}`}
              />
            </Grid>
            <Grid item xs={12}>
              <Label labelText={t("date")} required />
              <DatePicker
                sx={{
                  "&.MuiTextField-root": { width: "100% !important" },
                  ...globalStyle.textField,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Label labelText={t("from")} required />
              <TimePicker
                sx={{
                  "&.MuiTextField-root": { width: "100% !important" },
                  ...globalStyle.textField,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Label labelText={t("to")} required />
              <TimePicker
                sx={{
                  "&.MuiTextField-root": { width: "100% !important" },
                  ...globalStyle.textField,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Label labelText={t("frequency")} required />
              <CustomDropDown>
                <MenuItem value={"one_time"}>{t("oneTime")}</MenuItem>
                <MenuItem value={"every_week"}>{t("everyWeek")}</MenuItem>
              </CustomDropDown>
            </Grid>
            <Grid item xs={12}>
              <Label labelText={t("description")} required />
              <TextInput
                styleProps={{
                  "& .MuiInputBase-root": { padding: "0px" },
                  ...globalStyle.textField,
                }}
                placeholder={t("enterDescriptionOrNote")}
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        </Box>

        <Box p={2} borderTop={`1px solid ${palette.custom.borderColor}`}>
          <GlobalButton
            variant={"contained"}
            btnText={"apply"}
            handleClickBtn={() => setIsOpen(false)}
            styleProps={{
              height: 45,
            }}
          />
        </Box>
      </Stack>
    </Drawer>
  );
});

export default BlockTimeDrawer;
